import { useContext } from "react";

import { ShowLoadingScreenToUserContext } from "../_context";

export const useLoadingScreen = () => {
	const context = useContext(ShowLoadingScreenToUserContext);

	if (!context) {
		throw new Error("useLoadingScreen must be used within a ShowLoadingScreenToUserContext.Provider");
	}

	return context;
};
